import FormWrapper from '@components/search/forms/FormWrapper'
import ConstructionForm from '@components/search/forms/ConstructionForm'
import { frontpageLinks } from '@components/search/formLinks'

const ConstructionSearchpageForm = ({ query }) => {
    return (
        <FormWrapper
            Form={ConstructionForm}
            formLinks={frontpageLinks}
            overrideDefaultValues={query}
            active={3}
            linksOnTop
        />
    )
}

export default ConstructionSearchpageForm